export const tiType = {
  1: '选择题',
  5: '创作题'
}

export const tiDesc = {
  'choice': 1,
  'create': 5
}